import PropTypes from 'prop-types'
import React from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function SectionUptitle(props) {
  const { title } = props


  return (
    <span
      className="uptitle"
    >
      {title}
      <style jsx>{styles}</style>
    </span>
  )
}

SectionUptitle.propTypes = {
  title: PropTypes.string,
}

SectionUptitle.defaultProps = {
  title: ''
}

SectionUptitle = chainDecorators(decorators, SectionUptitle)

export default SectionUptitle
